<div class="mx-auto flex items-center gap-2 p-3">
  <!-- 이전 버튼 -->
  <button
    type="button"
    class="flex items-center cursor-pointer rounded-lg p-2 disabled:cursor-not-allowed"
    (click)="changePage((currentPage() ?? 1) - 1)"
    [disabled]="(currentPage() ?? 1) === 1"
  >
    <app-icon
      name="material-symbols:arrow-back-ios-rounded"
      class="size-4! text-zinc-600 ml-2"
    />
  </button>

  <!-- 페이지 번호 -->
  <div class="flex items-center gap-2">
    @for (page of visiblePages(); track $index) { @if (page === '...') {
    <span class="px-2 text-gray-400">…</span>
    } @else {
    <button
      type="button"
      class="flex h-6 w-6 cursor-pointer items-center justify-center rounded-full text-xs font-medium transition duration-300"
      [ngClass]="{
        'bg-primary-500 text-white': (currentPage() ?? 1) === page,
        'bg-white text-gray-700': (currentPage() ?? 1) !== page
      }"
      (click)="changePage(page)"
    >
      {{ page }}
    </button>
    } }
  </div>

  <!-- 다음 버튼 -->
  <button
    type="button"
    class="flex items-center cursor-pointer rounded-lg p-2 disabled:cursor-not-allowed"
    (click)="changePage((currentPage() ?? 1) + 1)"
    [disabled]="(currentPage() ?? 1) === (totalPages()?.length ?? 1)"
  >
    <app-icon
      name="material-symbols:arrow-forward-ios-rounded"
      class="size-4! text-zinc-600"
    />
  </button>
</div>
